<template>
	<!--v2/rankList/index.wxml-->
	<div class="ranklist">
		<div class="scroll-view_H" >
			<div v-for="(item, index) in rankName" :data-index="index" class="item " :class="[idx == index ? 'selectClass' : '']" @click="toggle">{{ item.menuname }}</div>
		</div>
		<div class="list">
			<div class="list-item">
				<!-- <block wx:for="{{ rankList }}"> -->
					<div class="item2 mtop" v-for="(item, index) in rankList">
						<div class="item01">
							<div class="item01-r01">
								<div class="item01-r01-01">
										<div v-for="(eitem, index) in item.prev[0].enrollinfo" class="num1">{{ eitem.number }}</div>
								</div>
								<div class="item01-r01-02">
									<div class="zhanwei" v-if="item.prev[0].enrollinfo.length == 0">
										<div>--</div>
										<div>--</div>
									</div>
									
										<div class="person" v-for="(citem, index) in item.prev[0].enrollinfo">
											<span class="name">{{ citem.name }}</span>
											<span class="score">{{ citem.score }}</span>
										</div>
	
								</div>
							</div>
							<div class="item01-r01 mtop">
								<div class="item01-r01-01" >
									<div class="item01-r01-01-001" v-if="item.prev.length == 2" >
										<div v-for="(eitem, index) in item.prev[1].enrollinfo" class="num1">{{ eitem.number }}
										</div>
										<div v-if="item.prev[1].enrollinfo.length == 1" class="num1">--
										</div>									
									</div>
								</div>
								<div class="item01-r01-02">
									<div class="zhanwei" v-if="item.prev.length == 1 || item.prev[1].enrollinfo.length  == 0 ">
										<div>--</div>
										<div>--</div>
									</div>
									<div class="newc" v-if="item.prev.length == 2 && item.prev[1].enrollinfo.length != 0">
										<div class="person"  v-for="(citem, index) in item.prev[1].enrollinfo">
											<span class="name">{{ citem.name }}</span>
											<span class="score">{{ citem.score }}</span>
										</div>
										<div class="person44" v-if="item.prev[1].enrollinfo.length == 1"><span>--</span></div>
									</div>
										
								</div>
							</div>

						</div>
						<div class="item02"></div>
						<div class="item03"></div>
						<div class="item04">

							<div class="p01">
								<span class="p01-txt11" v-if="item.enrollinfo.length == 0">--</span>
								<span class="p01-txt11" v-if="item.enrollinfo.length == 1 && item.enrollinfo[0].from  && item.enrollinfo[0].from != item.prev[0].groupnum">-</span>
								<span class="p01-txt2" v-if="item.enrollinfo.length == 1 && item.enrollinfo[0].from &&  item.enrollinfo[0].from == item.prev[0].groupnum">{{ item.enrollinfo[0].name }}</span>
								<span class="p01-txt11" v-if="item.enrollinfo.length == 2 && item.enrollinfo[0].from && item.enrollinfo[0].from != item.prev[0].groupnum">-</span>
								<span class="p01-txt2" v-if="item.enrollinfo.length == 2 && item.enrollinfo[0].from && item.enrollinfo[0].from == item.prev[0].groupnum">{{ item.enrollinfo[0].name }}</span>
							</div>
							<div class="p01">
								<span class="p01-txt11" v-if="item.enrollinfo.length == 0">--</span>
								<span class="p01-txt11" v-if="item.enrollinfo.length == 1 && item.enrollinfo[0].from && item.prev[1] && item.enrollinfo[0].from != item.prev[1].groupnum">-</span>
								<span class="p01-txt2" v-if="item.enrollinfo.length == 1 && item.enrollinfo[0].from && item.prev[1] && item.enrollinfo[0].from == item.prev[1].groupnum">{{ item.enrollinfo[1].name }}</span>
								<span class="p01-txt11" v-if="item.enrollinfo.length == 2 && item.enrollinfo[1].from && item.prev[1] && item.enrollinfo[1].from != item.prev[1].groupnum">-</span>
								<span class="p01-txt2" v-if="item.enrollinfo.length == 2 && item.enrollinfo[1].from && item.prev[1] && item.enrollinfo[1].from == item.prev[1].groupnum">{{ item.enrollinfo[1].name }}</span>
							</div>
						</div>
					</div>
				<!-- </block> -->

			</div>
		</div>

	</div>

</template>

<script>
	export default {
		name: "ranklist",
		data() {
			return {
				// matchid: 5511,
				// trackid: 146,
				matchid: "",
				trackid: "",
				// matchid: 8476,
				// trackid: 185,
				
				idx: 0,
				type: '',
				rankName: [],
				
				rankList: [],
			}
		},
		mounted() {
			let _this = this
			this.matchid = this.$route.query.matchid
			this.trackid = this.$route.query.trackid
			var data = {
				matchid: this.matchid,
				trackid: this.trackid
			}

			this.$api.rank
				.getRankLName(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						
						_this.rankName = res.data,
						_this.type = res.data[0].type
						
						let param = {
							matchid: _this.matchid,
							trackid: _this.trackid,
							type: _this.type
						}
						_this.getRankList(param)
					}
					// this.$toast.clear();
				});
		},
		methods: {
			toggle(e){
				console.log("7777", e)
				let idx = e.target.dataset.index;
				
				this.idx = idx,
				this.type = this.rankName[idx].type,
				this.rankList = []
				
				let param = {
					matchid: this.matchid,
					trackid: this.trackid,
					type: this.type
				}
				this.getRankList(param)
		
			},
			getRankList(data){
				var _this = this;
				this.$api.rank.getRankList(data).then(res => {
					if (res.status == 200 && res.data) {
						_this.rankList = res.data
					}
				});
			},
		}
	}
</script>

<style scoped>
	/* v2/rankList/index.wxss */
	.scroll-view_H {
		position: fixed;
		width: 100%;
		overflow-x: scroll;
		top: 0;
		white-space: nowrap;
		background: #F62C3D;
		z-index: 1000;
		font-size: .28rem;
	}

	.item {
		width: 2.24rem;
		text-align: center;
		display: inline-block;
		color: rgba(255, 255, 255, 0.60);
		height: .9rem;
		line-height: .90rem;
		font-size: .28rem;
	}

	.list {
		/* color: #000; */
		box-sizing: border-box;
		padding: 1.38rem .25rem .78rem .25rem;
	}

	.item01-r01 {
		display: flex;
	}

	.num1 {
		width: .68rem;
		/* height: 40rpx; */
		background: #FFD255;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: .24rem;
		color: rgba(0, 0, 0, 0.85);
	}

	.item01-r01-01 {
		width: .68rem;
		height: .86rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.item01-r01-01-001 {
		width: .68rem;
		height: .86rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.item01-r01-02 {
		width: 2.78rem;
		height: .86rem;
		box-sizing: border-box;
		border: .02rem solid #E7E5E5;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 0 .15rem 0 .25rem;
		background: #f5f5f5;
	}
	.newc{
		width: 2.78rem;
		height: .86rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		background: #f5f5f5;
	}

	.person {
		width: 100%;
		font-size: .24rem;
		color: rgba(0, 0, 0, 0.85);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.person44{
		width: 100%;
		font-size: .24rem;
		color: rgba(0, 0, 0, 0.85);
		display: flex;
		justify-content: center;
	}

	.mtop {
		margin-top: .20rem;
	}

	.item2 {
		display: flex;
		align-items: center;
	}

	.item02 {
		width: .19rem;
		height: 1.06rem;
		border: .02rem solid #E7E5E5;
		border-left: none;
	}


	.item03 {
		width: .21rem;
		height: .01rem;
		background: #E7E5E5;
	}


	.item04 {
		width: 3.08rem;
		height: .86rem;
		border: .02rem solid #E7E5E5;
		background: #f5f5f5;
	}

	.p01 {
		height: .43rem;
		line-height: .43rem;
		position: relative;
		box-sizing: border-box;
		padding-left: .60rem;
		font-size: .24rem;
	}

	.p01 span {
		font-size: .24rem;
		color: rgba(0, 0, 0, 0.85);
	}

	.p01-txt1 {
		position: absolute;
		left: .10rem
	}

	.selectClass {
		font-size: .28rem;
		color: #FFFFFF;
	}

	.list-item {}

	.list-item-right {
		width: .19rem;
		height: 2.01rem;
		border: .02rem solid #E7E5E5;
		border-left: none;
	}

	.zhanwei div {
		height: .43rem;
		line-height: .43rem;
		font-size: .24rem;
	}
</style>
